// VideoSection.js
import React from 'react';
import './VideoSection.css';
// import videoSrc from '../assests/image/inline_image_preview.jpg'; // Adjust the path to your video file

const VideoSection = () => {
    return (
        <section className="video-section">
            <h2 className="section-title">Sample Video</h2> {/* Add the title above the video section */}
            <div className="container">
                <div className="video-window">
                    <div className="video-content">
                        {/* Add your video player or any other video-related content here  */}
                        {/* Example:  */}
                        <video controls>
                            {/* <source src={videoSrc} type="majorprojectapp\src\assests\detected_objects_video.mp4" /> */}
                        </video>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default VideoSection;
